module.exports = __webpack_public_path__ + "img/mo4.f694ee26.png";